import React from "react";

const Servicelist = ({ Symtams }) => {
  return (
    <>
      <div className="mx-auto">
        <ul className="list-disc text-left sm:text-lg text-base">
          {Symtams.map((item, index) => (
            <li key={index} className="pt-2 md:w-[380px] font-roboto">{item}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Servicelist;
